export default "__VITE_ASSET__CEsgHL9u__"